import Form from "./Components/Form";

function App() {
  return (
    <div className="wrapper">
      <h3>TODOAPP USING REACT HOOKS AND LOCALSTORAGE</h3>
      <div className="form-and-todo-box">
        <Form/>
      </div>
    </div>
  );
}

export default App;
